import axios from "../../utils/axios";

export function getUdiInfos(query) {
    return axios({
        url: "/udiwms/udiinfo/filterUdi",
        method: "get",
        params: query
    });
}

export function vailUdiCode(query) {
    return axios({
        url: "/udidl/device/vailUdiCode",
        method: "get",
        params: query
    });
}


export function filterCompany(query) {
    return axios({
        url: "/udiwms/udiinfo/filterCompany",
        method: "get",
        params: query
    });
}

export function filterByUuid(query) {
    return axios({
        url: "/udiwms/udiinfo/local/filterByUuid",
        method: "get",
        params: query
    });
}

export function filterByVersion(query) {
    return axios({
        url: "/udiwms/syncdi/version",
        method: "get",
        params: query
    });
}

export function superSearch(query) {
    return axios({
        url: "/udiwms/udiinfo/superSearch",
        method: "get",
        params: query
    });
}

export function dlLastVersionByDi(query) {
    return axios({
        url: "/udiwms/udiinfo/dlLastVersionByDi",
        method: "get",
        params: query
    });
}





